import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {AlertTypesEnum} from './shared/interfaces/AlertTypesEnum';
import {NotifierService} from 'angular-notifier';
import {v4 as uuid} from 'uuid';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ErrorService} from './shared/services/error.service';
import { Observable } from 'rxjs';
import { InventoryState } from './shared/states/inventory/inventory.state';
import { Select, Store } from '@ngxs/store';
import { GetLibertyRxLoadStatus } from './shared/states/inventory/inventory.actions';
import { IUser } from './shared/interfaces/user.interface';
import { PharmacyState } from './shared/states/pharmacy/pharmacy.state';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AlertMessageService } from './shared/services/alert-message.service';
import { PinService } from './shared/services/pin.service';
import { AuthState } from './shared/states/auth/auth.state';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
  title = 'C2KeepSpa';

  @ViewChild('customNotification') customNotification;
  @ViewChild('pillLoader') pillLoader;

  @Select(InventoryState.loadingLibertyRxInventory) loadingLibertyRxInventory$: Observable<boolean>;
  @Select(PharmacyState.currentPharmacy) pharamcyId$: Observable<IUser>;

  constructor(
    private router: Router,
    private notifierService: NotifierService,
    private errorService: ErrorService,
    private store: Store,
    public alertService: AlertMessageService,
    public pinService: PinService
  ) {
    this.router.events.subscribe((event) => {
      let checkForLibertyRxLoading = false;

      if (event instanceof NavigationStart && !router.navigated) { //detect after page refresh
        if (!event.url.match("auth") && !event.url.match("setup")) {
          checkForLibertyRxLoading = true;
        }
      } else if (event instanceof NavigationEnd) {
        if (!event.url.match("auth") && !event.url.match("setup")) {
          checkForLibertyRxLoading = true;
        }
      }
      // if (checkForLibertyRxLoading && this.store.selectSnapshot(AuthState.accessToken)) {
      //   this.store.dispatch(new GetLibertyRxLoadStatus());
      // }
    });

  }

  ngAfterViewInit(): void {
    this.errorService.errorMessage$
      .pipe(untilDestroyed(this))
      .subscribe((error: string) => {
        if (error) {
          this.openAlert(error);
        }
      });

    this.loadingLibertyRxInventory$
      .pipe(untilDestroyed(this))
      .subscribe(loading => {
        if(!loading) {
          this.pillLoader?.ngOnDestroy();
        }
      });
  }

  openAlert(error: string): void {
    this.notifierService.show({
      template: this.customNotification,
      type: AlertTypesEnum.Error,
      message: error,
      id: uuid(),
    });
  }

  closeAlert(id: string): void {
    this.notifierService.hide(id);
  }
}
